export default function Close() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M17.5 2.5L2.5 17.5" stroke="#1A1F1F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M2.5 2.5L17.5 17.5" stroke="#1A1F1F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}